import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form, Formik } from 'formik';
import { Box, Grid } from '@mui/material';
import * as Yup from 'yup';

import useNotification from '../../../../../core/hooks/use_notification';
import { updateAutomaticCouponSettingTranslationNotificationData } from '../../../../../core/utils/notification_utils';
import TextFieldFormik from '../../../../common/text_field';
import { SubmitButton } from '../../../../common/button';
import { getAutomaticCouponSettingTranslationState } from '../../../../../features/coupon/get_automatic_coupon_setting_translation';
import { updateAutomaticCouponSettingTranslationAction, updateAutomaticCouponSettingTranslationState } from '../../../../../features/coupon/update_automatic_coupon_setting_translation';
import SectionPaper from '../../../../common/section_paper';
import BottomActionBar from '../../../../common/bottom_action_bar';

const AutomaticCouponSettingTranslationForm = ({ automaticCouponType, languageCode }) => {
    const dispatch = useDispatch();
    const { showNotification } = useNotification();

    const getAutomaticCouponSettingTranslation = useSelector(getAutomaticCouponSettingTranslationState);
    const updateAutomaticCouponSettingTranslation = useSelector(updateAutomaticCouponSettingTranslationState);

    const initialValues = {
        name: getAutomaticCouponSettingTranslation?.data?.name || '',
        description: getAutomaticCouponSettingTranslation?.data?.description || ''
    };

    const schema = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required()
    });

    const onSubmit = (values) => {
        const form = {
            ...values,
            languageCode
        };

        dispatch(updateAutomaticCouponSettingTranslationAction({ form, automaticCouponType }))
            .then(response => showNotification(updateAutomaticCouponSettingTranslationNotificationData(response)));
    };

    return (
        <Formik
            initialValues={ initialValues }
            validationSchema={ schema }
            validateOnChange={ false }
            validateOnBlur={ false }
            onSubmit={ onSubmit }>
            { () => (
                <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 } }>
                    <Box sx={ { flexGrow: 1, pb: 4 } }>
                        <SectionPaper title="Tłumaczenie treści">
                            <Grid container spacing={ 3 }>
                                <Grid item xs={ 12 }>
                                    <TextFieldFormik name="name" label="Nazwa" required/>
                                </Grid>
                                <Grid item xs={ 12 }>
                                    <TextFieldFormik name="description" label="Opis" multiline rows={ 4 } required/>
                                </Grid>
                            </Grid>
                        </SectionPaper>
                    </Box>

                    <BottomActionBar>
                        <Box sx={ { display: 'flex', justifyContent: 'flex-end', width: '100%' } }>
                            <SubmitButton
                                isLoading={ updateAutomaticCouponSettingTranslation?.loading }>Zapisz</SubmitButton>
                        </Box>
                    </BottomActionBar>
                </Box>
            ) }
        </Formik>
    );
};

export default AutomaticCouponSettingTranslationForm;